import { create } from "zustand";
import { persist } from "zustand/middleware";

/**
 * UI store — genuine client UI preferences that must survive a reload. Persisted to
 * localStorage via the persist middleware under a versioned key so we can migrate later.
 *
 * Kept intentionally minimal (just the sidebar). Add prefs as real screens need them — no
 * speculative fields. Locale is NOT here: i18next's own detector persists language (Phase 7).
 */
interface UIState {
  sidebarCollapsed: boolean;
  setSidebarCollapsed: (collapsed: boolean) => void;
  toggleSidebar: () => void;
}

export const useUIStore = create<UIState>()(
  persist(
    (set) => ({
      sidebarCollapsed: false,
      setSidebarCollapsed: (collapsed) => set({ sidebarCollapsed: collapsed }),
      toggleSidebar: () =>
        set((state) => ({ sidebarCollapsed: !state.sidebarCollapsed })),
    }),
    {
      name: "dz-ui", // versioned localStorage key
      version: 1,
    }
  )
);
